<template>
  <div>
    <div v-if="video">
      <img v-if="thumbnailUrl" :key="url" class="video-placeholder" :src="thumbnailUrl" alt="video thumbnail" />
      <div v-else class="black-bg flex align-center video-placeholder">
        <loader-static class="center" />
      </div>
      <br />
      <div class="underline clear" @click="handleChangeVideoClick">change</div>
    </div>
    <div v-else>
      <input
        v-show="!uploadInProgress"
        accept="video/mp4,video/x-m4v,video/*"
        type="file"
        @change="handleInputChange"
      />
      <div v-if="uploadInProgress">Uploading Video... {{ uploadInProgressPercentage }}%</div>
    </div>
  </div>
</template>
<script>
import VideoApi from "@/services/api/videoApi";
import * as UpChunk from "@mux/upchunk";
import ProductApi from "@/services/api/productApi";

const { getProduct } = new ProductApi(),
  { deleteVideo, getAssetId, getVideoUploadUrl, setVideo } = new VideoApi();

export default {
  name: "VideoUploader",
  props: ["productId", "video"],
  data: function () {
    return {
      POLL_INTERVAL: 1000,
      uploadUrl: null,
      uploadInProgressPercentage: 0,
      thumbnailUrl: false,
      uploadInProgress: false,
    };
  },
  watch: {
    video: function () {
      this.getThumbnail(this.video.url);
    },
  },
  beforeMount() {
    if (this.video?.url){
      this.getThumbnail(this.video.url);
    }
  },
  methods: {
    handleInputChange: async function (event) {
      const { data } = await getVideoUploadUrl(this.productId),
        uploadId = data.upload_id,
        upload = UpChunk.createUpload({
          endpoint: data.url,
          file: event.target.files[0],
          chunkSize: 768,
        });
      this.uploadInProgress = true;
      this.$emit("upload-changed");
      upload.on("error", () => {
        this.$swal("Attention", "Something went wrong. Please Try again");
      });
      upload.on("progress", (progress) => {
        this.uploadInProgressPercentage = progress.detail.toFixed() - 1;
      });
      upload.on("success", () => {
        this.pollForAssetID(uploadId);
      });
    },
    pollForAssetID: async function (uploadId) {
      const api = async () => {
        const { data } = await getAssetId(uploadId);
        return data.processed ? data.playback_ids : false;
      };
      this.$utils
        .poll({
          fn: api,
          validate: (asset) => Boolean(asset),
          interval: this.POLL_INTERVAL,
        })
        .then(async (playback) => {
          this.uploadInProgress = false;
          const video = {
              entity_type: "PRODUCT",
              url: playback[0].id,
            },
            { data } = await getProduct(this.productId);
          data.video && (await deleteVideo(data.video.id));
          setVideo(this.productId, video).then((response) => {
            this.$emit("upload-changed", {
              entity_id: this.productId,
              entity_type: "PRODUCT",
              url: playback[0].id,
              id: response.data.id,
            });
          });
        })
        .catch(() => {
          this.$emit("upload-changed");
          this.$swal("Attention", "Something went wrong. Please Try again");
        });
    },
    getThumbnail: function (id) {
      const MUX_THUMB_URL = `https://image.mux.com/${id}/thumbnail.png?width=214&height=121&fit_mode=pad`;
      fetch(MUX_THUMB_URL, {
        method: "HEAD",
      }).then((res) => {
        if (res.ok) {
          this.thumbnailUrl = MUX_THUMB_URL;
        } else {
          setTimeout(() => {
            this.getThumbnail(id);
          }, this.POLL_INTERVAL);
        }
      });
    },
    handleChangeVideoClick: function () {
      this.$emit("remove-video");
    },
  },
};
</script>
<style lang="scss" scoped>
.video-placeholder {
  width: 214px;
  height: 121px;
}
</style>
